import React from 'react';
import type { FieldRenderProps } from 'react-final-form';

import type { IProps as AmountControlProps } from '../ui/AmountControl';
import { AmountControl } from '../ui/AmountControl';

export const FieldAmountControl: React.FC<FieldRenderProps<number | undefined> & AmountControlProps> = ({
  input,
  meta,
  ...props
}) => <AmountControl {...input} {...props} error={meta.touched && meta.error && String(meta.error)} />;
